import type { ReactNode } from 'react';

export const symbol_align_vertical_center: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M304.5-134.58Q290-149.17 290-170v-280H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h180v-280q0-20.83 14.62-35.42Q319.24-840 340.12-840q20.88 0 35.38 14.58Q390-810.83 390-790v280h180v-160q0-20.83 14.62-35.42Q599.24-720 620.12-720q20.88 0 35.38 14.58Q670-690.83 670-670v160h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H670v160q0 20.83-14.62 35.42Q640.76-240 619.88-240q-20.88 0-35.38-14.58Q570-269.17 570-290v-160H390v280q0 20.83-14.62 35.42Q360.76-120 339.88-120q-20.88 0-35.38-14.58Z"
		/>
	</svg>
);
